module.exports = __webpack_public_path__ + "img/icon-cc4.be7ad262.svg";